
import React from "react";
import { Form } from "@/components/ui/form";
import { ContactNameField } from "./form/ContactNameField";
import { ContactEmailField } from "./form/ContactEmailField";
import { ContactPhoneField } from "./form/ContactPhoneField";
import { ContactRoleField } from "./form/ContactRoleField";
import { ContactFormActions } from "./form/ContactFormActions";
import { useContactForm } from "./form/useContactForm";
import { ContactPerson } from "@/lib/types";

interface ContactFormProps {
  contact?: ContactPerson;
  mode: "create" | "edit";
  onSuccess?: (contact: ContactPerson) => void;
  minimal?: boolean;
}

export function ContactForm({ contact, mode, onSuccess, minimal = false }: ContactFormProps) {
  const { form, isSubmitting, onSubmit } = useContactForm({
    contact,
    mode,
    onSuccess
  });

  return (
    <Form {...form}>
      <form onSubmit={form.handleSubmit(onSubmit)} className="space-y-6">
        <div className={minimal ? "grid gap-4" : "grid gap-4 md:grid-cols-2"}>
          <ContactNameField form={form} />
          <ContactEmailField form={form} />
          <ContactPhoneField form={form} />
          <ContactRoleField form={form} />
        </div>

        <ContactFormActions 
          isSubmitting={isSubmitting} 
          mode={mode} 
          minimal={minimal} 
        />
      </form>
    </Form>
  );
}
